// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__3pCSi","footer":"footer__F4GU7","footer1":"footer1__3-JQx","footer2":"footer2__EbIkH","infoTitle":"infoTitle__XKF2y","title":"title__2XEEY","titleLetterSpace":"titleLetterSpace__NGOl_","formText":"formText__2sNMf","text":"text__2Bew0","infoText":"infoText__1SQiP","connect":"connect__11n-x","images":"images__2aVh4","logo":"logo__8_iPN","dezeen":"dezeen__2Omzg","nice":"nice__2OPzz","economist":"economist__1iV6V","social":"social__5TxZu","connectContainer":"connectContainer__MtgE5","connectTitle":"connectTitle__oy6c5","copy":"copy__3ckD9","copyText":"copyText__2D8bE"};


//////////////////
// WEBPACK FOOTER
// ./components/footer-new/style.styl
// module id = woc8
// module chunks = 0